import { createContext, ReactNode, useState } from 'react';
import { getActiveCountryByCode } from '../calculation/calculations';
import { GeneralRegion, ActiveCountryCode } from '../configs/countries';

export type WidgetType = {
  locale: string;
  countryCode: ActiveCountryCode;
  regionKey: GeneralRegion;
};

export const WidgetContext = createContext<WidgetType>({
  locale: 'en_nz',
  countryCode: 'NZ',
  regionKey: 'DEFAULT',
});

type ProviderProps = {
  children: ReactNode;
  countryCode: ActiveCountryCode;
  regionKey: GeneralRegion;
};

export const WidgetProvider = ({
  children,
  countryCode,
  regionKey,
}: ProviderProps): JSX.Element => {
  const country = getActiveCountryByCode(countryCode);
  const locale = country.locale;
  return (
    <WidgetContext.Provider
      value={{
        locale: locale,
        regionKey,
        countryCode,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
